/* eslint-disable */
import React from "react";

const FilterButton = ({
  filterKey,
  icon,
  label,
  filter2,
  setFilter2,
  orders,
}) => {
  const isSameArray = (a, b) =>
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val) => b.includes(val));

  const isActive = isSameArray(filter2, filterKey);
  const count = orders.filter((order) =>
    filterKey.includes(order.CompanyDeleveryStatus)
  ).length;



  return (
    <button
      onClick={() => setFilter2(filterKey)}
      className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${isActive
          ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
          : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
        }`}
    >
      <div
        className={`w-8 h-8 rounded-lg ${isActive ? "bg-[#efd3ff] dark:bg-[#181919]" : "bg-[#faf1ff] dark:bg-[#181919]"
          } flex items-center justify-center mr-3`}
      >
        {icon}
      </div>

      <div className="text-left mx-2">
        <div
          className={`text-sm font-medium ${isActive ? "text-[#9e68ba]" : "text-gray-800 dark:!text-gray-300"
            }`}
        >
          {label}
        </div>
        <div
          className={`font-bold ${isActive ? "text-[#9e65bb]" : "text-[#9e68ba]"
            }`}
        >
          {count}
        </div>
      </div>
    </button>
  );
};

export default FilterButton;
